/**
 * CSV export pro DataTable.
 *
 * Cílová skupina je český ad-ops tým v Excelu, takže:
 *  - oddělovač `;` (český Excel bere `,` jako desetinnou čárku)
 *  - UTF-8 BOM, jinak Excel rozbije diakritiku
 *  - desetinná čárka v číslech
 */

export interface CsvColumn<T> {
  key: string;
  header: string;
  value: (row: T) => string | number | null | undefined;
}

function escapeCell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  let text = typeof value === 'number' ? String(value).replace('.', ',') : String(value);
  // Ochrana proti CSV injection — Excel by `=`, `+`, `-`, `@` spustil jako vzorec.
  if (/^[=+\-@\t\r]/.test(text)) {
    text = `'${text}`;
  }
  if (/[";\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function toCsv<T>(rows: readonly T[], columns: readonly CsvColumn<T>[]): string {
  const header = columns.map((c) => escapeCell(c.header)).join(';');
  const body = rows
    .map((row) => columns.map((c) => escapeCell(c.value(row))).join(';'))
    .join('\r\n');
  return `${header}\r\n${body}`;
}

export function downloadCsv(filename: string, csv: string): void {
  // BOM: bez něj Excel načte UTF-8 jako windows-1250 a diakritika se rozsype.
  // Zapsaný jako escape schválně — neviditelný znak ve zdrojáku nikdo neuhlídá.
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** Název souboru s obdobím: `overview_2026-07-01_2026-07-07.csv` */
export function csvFilename(prefix: string, from: string, to: string): string {
  return `${prefix}_${from}_${to}.csv`;
}
